import {PropsWithChildren} from 'react';
import cx from 'classnames';

type Position =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'centerLeft'
  | 'center'
  | 'centerRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

const CLASS_NAME_BY_POSITION: Record<Position, string> = {
  topLeft: '',
  topCenter: 'justify-center',
  topRight: 'justify-end',
  centerLeft: 'items-center',
  center: 'justify-center items-center',
  centerRight: 'justify-end items-center',
  bottomLeft: 'items-end',
  bottomCenter: 'justify-center items-end',
  bottomRight: 'justify-end items-end',
};

type TimelineElementContainerProps = PropsWithChildren<{
  position: Position;
}>;

/**
 * A wrapper component to easily position timeline elements.
 */
export const TimelineElementContainer: React.FC<
  TimelineElementContainerProps
> = ({children, position}) => {
  return (
    <div
      className={cx(
        'h-full w-full flex px-10 py-4',
        CLASS_NAME_BY_POSITION[position]
      )}
    >
      {children}
    </div>
  );
};
